import { Box, Text } from '@domain-group/suit-theme'

import Comment from '@components/Comment'

import formatDate from '@functions/formatDate'
import { stringHasContent } from '@functions/utility'

import type { CommentModel } from '@models/types'

interface CommentsProps {
  comments: CommentModel[],
  hasFilteredComments: boolean,
  latestCommentDate: string,
}

const Comments = (props: CommentsProps) => {
  const {
    comments, hasFilteredComments, latestCommentDate,
  } = props

  if (!hasFilteredComments){
    return (
      <Text color="bodyFontLightColor" fontSize="small" marginTop="large">
        No review requests found.
      </Text>
    )
  }

  return (
    <>
      {comments.map((comment, index) => {
        const isLastComment = index === comments.length - 1

        // @ts-expect-error TS2339
        const commentDateString = comment?.dates?.created?.date_time ?? ''
        const commentDate = stringHasContent(commentDateString)
          ? formatDate(commentDateString, 'dd/MM/yyyy HH:mm') : ''
        const recent = commentDate === latestCommentDate

        return (
          <Box
            key={comment.id}
            style={{
              position: 'relative',
            }}
          >
            <Comment
              boxProps={{
                borderBottom: isLastComment ? 'none' : '1px solid',
              }}
              comment={comment}
              isLastComment={isLastComment}
            />

            {!recent && (
              <Box
                height={isLastComment ? 'calc(100% - 16px)' : 'calc(100% - 32px)'}
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.5)',
                  position: 'absolute',
                  right: '0',
                  top: '0',
                }}
              />
            )}
          </Box>
        )
      })}
    </>
  )
}

export default Comments
